
import React, { useState, useEffect } from 'react';
import { athletesAPI } from '../../api';
import { toast } from '../common/Notifier';

export const AthleteEditModal = ({ athlete, onClose, onSaved }) => {
  const [form, setForm] = useState({
    name: '',
    language: 'ru',
    weight: '',
    weekly_volume_km: '',
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (athlete) {
      setForm({
        name: athlete.name || '',
        language: athlete.language || 'ru',
        weight: athlete.weight || '',
        weekly_volume_km: athlete.weekly_volume_km || '',
      });
    }
  }, [athlete]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
        await athletesAPI.adminUpdate(athlete.id, {
          name: form.name,
          language: form.language,
        });
      toast.success('Атлет обновлён');
      onSaved();
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.error || 'Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  if (!athlete) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-lg p-6 max-w-md w-full space-y-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold">Редактировать: {athlete.name}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">✕</button>
        </div>

        <form onSubmit={handleSave} className="space-y-3">
          <div>
            <label className="block text-sm text-gray-600 mb-1">Имя</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-600 mb-1">Язык</label>
            <select
              value={form.language}
              onChange={(e) => setForm({ ...form, language: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            >
              <option value="ru">🇷🇺 Русский</option>
              <option value="uk">🇺🇦 Українська</option>
              <option value="en">🇬🇧 English</option>
            </select>
          </div>

          <div className="grid grid-cols-2 gap-3 text-sm text-gray-500 border-t pt-3">
            <div>Telegram: {athlete.telegram_id ? `✅ ${athlete.telegram_id}` : '❌ не привязан'}</div>
            <div>VDOT: {athlete.current_vdot || '—'}</div>
            <div>Регистрация: {athlete.created_at ? new Date(athlete.created_at).toLocaleDateString('ru') : '—'}</div>
            <div>Последний вход: {athlete.last_login ? new Date(athlete.last_login).toLocaleDateString('ru') : '—'}</div>
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-gray-600 hover:text-gray-800">
              Отмена
            </button>
            <button
              type="submit"
              disabled={saving}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg disabled:opacity-50"
            >
              {saving ? 'Сохранение...' : 'Сохранить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};